import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { all_routes } from "../../Router/all_routes";
import { useForm } from "react-hook-form"; // Import useForm from react-hook-form

import Addunits from "../../core/modals/inventory/addunits";
import AddCategory from "../../core/modals/inventory/addcategory";
import AddBrand from "../../core/modals/addbrand";
import { GetRequest, PatchRequest } from "../../Api/ApiFunctions";
import { ApiUrl, ConfUrl } from "../../Api/EndPoints";
import MultipleImage from "./Components/MultipleImage";
import { ConfImageUploadService, ImageDataModalRequired } from "./constants";
import MultiplePoints from "./Components/MultiplePoints";

const ProductRange = () => {
  const route = all_routes;
  const [Responsibilities, setResponsibilities] = useState([]);
  const [banner, setBanner] = useState([]);
  const [imageSet, setImageSet] = useState([]);
  const navigate = useNavigate();
  const {
    // register,
    handleSubmit,
    // setValue,
    // getValues,
    // reset,
    formState: { isSubmitting },
  } = useForm(); // Set up useForm

  const fetchData = async () => {
    const res = await GetRequest(
      `${ApiUrl.configuration}${ConfUrl.productRange}`
    );
    if (res) {
      setBanner(res?.value?.banner ? [res.value.banner] : []);
      setImageSet(res?.value?.imageSet ?? []);
      setResponsibilities(res?.value?.products ?? []);
    }
  };

  useEffect(() => {
    fetchData();
  }, []);

  const onSubmit = async () => {
    let Req = { products: Responsibilities };

    if (banner?.length > 0) {
      let imgKey = null;
      if (banner[0]?.image instanceof File) {
        imgKey = await ConfImageUploadService(banner[0]?.image);
      }
      Req.banner = {
        key: banner[0]?.key,
        image: imgKey ? imgKey : banner[0]?.image,
        heading: banner[0]?.heading,
        subHeading: banner[0]?.subHeading,
      };
    }

    Req.imageSet = await Promise.all(
      imageSet.map(async (it) => {
        let imgKey = null;
        if (it.image instanceof File) {
          imgKey = await ConfImageUploadService(it.image);
          console.log(it.image, "image");
        }
        return {
          key: it.key,
          image: imgKey ? imgKey : it.image,
        };
      })
    );

    const resp = await PatchRequest(
      `${ApiUrl.configuration}${ConfUrl.productRange}`,
      Req
    );
    if (resp) {
      navigate(route.jobapplication);
    }
  };

  return (
    <div className="page-wrapper">
      <div className="content">
        <div className="page-header">
          <div className="add-item d-flex">
            <div className="page-title">
              <h4>Product Range</h4>
              {/* <h6>Create new Career</h6> */}
            </div>
          </div>
        </div>
        {/* /add */}
        <form onSubmit={handleSubmit(onSubmit)}>
          <div className="card">
            <div className="card-body add-product pb-0">
              <div className="row">
                <h4>
                  <u>Banner</u>
                </h4>
                <div className="col-12">
                  <MultipleImage
                    id="banner"
                    dataSource={banner}
                    setDataSource={setBanner}
                    DataRequired={[
                      ImageDataModalRequired.image,
                      ImageDataModalRequired.heading,
                      ImageDataModalRequired.description,
                    ]}
                    DataLimit={1}
                  />
                </div>
                <h4>
                  <u>Image Set</u>
                </h4>
                <div className="col-12">
                  <MultipleImage
                    id="imageSet"
                    dataSource={imageSet}
                    setDataSource={setImageSet}
                    DataRequired={[ImageDataModalRequired.image]}
                    DataLimit={4}
                  />
                </div>
                <MultiplePoints
                  Responsibilities={Responsibilities}
                  setResponsibilities={setResponsibilities}
                />
              </div>
            </div>
          </div>
          <div className="col-lg-12">
            <div className="btn-addproduct mb-4">
              <button type="button" className="btn btn-cancel me-2">
                Cancel
              </button>

              <button
                type="submit"
                className="btn btn-submit"
                disabled={isSubmitting}
              >
                {isSubmitting ? (
                  <span className="spinner-border spinner-border-sm"></span>
                ) : (
                  "Save Product Range"
                )}
              </button>
            </div>
          </div>
        </form>
        {/* /add */}
      </div>
      <Addunits />
      <AddCategory />
      <AddBrand />
    </div>
  );
};

export default ProductRange;
